import React, { useContext } from 'react';
import {
  DefaultLayout,
  ExternalAppsContext,
  fetchUserApps,
  Footer,
  NotificationBar,
  TopBar,
  TopBarLeft,
  TopBarRight,
  useAuthActions,
  useNotificationsBar,
  UserProfileContext,
} from '@texas-education-exchange/edx-portal-shared';
import { Flex } from '@chakra-ui/react';
import UserSyncBannerMessage from '../components/Banner/UserSyncBannerMessage';
import useUserSyncBanner from '../hooks/userSyncBanner.hook';
import { SYNC_BANNER_NOTIFICATION_ID } from '../utils/userSyncBannerHelper';
import RootLayout from './RootLayout';

const DefaultLayoutWrapper = ({
  auth,
  edxAppConfig,
  notificationBarMessage,
  notificationId,
  isClosingSession,
  onLogin,
  onLogout,
  userData,
  isLoadingDone,
}) => {
  const { userProfile } = useContext(UserProfileContext);
  const { externalApps } = useContext(ExternalAppsContext);
  const { handleChangeTenantId } = useAuthActions();

  const { showNotificationsBar, onCloseNotificationsBar } = useNotificationsBar({ show: true });
  const { showSyncBanner, supportUrl } = useUserSyncBanner({
    auth,
    userData,
  });

  const handleTestClick = async () => {
    if (auth.user && userProfile && edxAppConfig) {
      const appsList = await fetchUserApps(
        auth.user.access_token,
        userProfile?.tenantId,
        edxAppConfig.api.baseUri,
      );

      console.log('test list', appsList);
    }
  };

  const moreOptions = [
    { name: 'Account Info', url: null },
    { name: 'Online Community', url: null },
    { name: 'Help', url: null },
  ];

  return (
    userProfile && (
    <DefaultLayout
      topBar={(
        <TopBar
          leftComponent={(
            <TopBarLeft
              appName={edxAppConfig.app.subtitle}
              list={externalApps}
              menuOptions={moreOptions}
            />
                    )}
          rightComponent={(
            <TopBarRight
              profileData={userProfile}
              isClosingSession={isClosingSession}
              onLogin={onLogin}
              onLogout={onLogout}
              onChangeTenantId={handleChangeTenantId}
              ready={isLoadingDone}
            />
                    )}
        />
            )}
      notificationBar={(
        <Flex
          onClick={handleTestClick}
          w="full"
          id="NotificationBar"
          // The shared NotificationBar always renders a close control and
          // stores the dismissal. Hiding that control is the only way this
          // app can keep the sync reminder on screen until the job is enabled.
          sx={showSyncBanner ? {
            '.notification-bar-close-button': { display: 'none' },
          } : undefined}
        >
          <NotificationBar
            show={showSyncBanner || showNotificationsBar}
            onClose={onCloseNotificationsBar}
            message={showSyncBanner ? undefined : notificationBarMessage}
            notificationId={showSyncBanner ? SYNC_BANNER_NOTIFICATION_ID : notificationId}
          >
            {showSyncBanner ? <UserSyncBannerMessage supportUrl={supportUrl} /> : null}
          </NotificationBar>
        </Flex>
            )}
      content={(
        <RootLayout userData={userData} />
      )}
      footer={<Footer />}
    />
    )
  );
};

export default DefaultLayoutWrapper;
